import React from 'react';
import type { ExtendWithCommonProps } from '../../types';
import { Icon, type IconProps } from '../icon/icon';
import { Spinner } from '../spinner/spinner';
import { type ButtonProps } from './button';
import { useButton } from './button-context';

export type ButtonIconProps = ExtendWithCommonProps<
  {
    /** If true, replaces icon with <Spinner>. */
    loading?: ButtonProps['loading'];
  },
  IconProps
>;

export const ButtonIcon = React.forwardRef<
  React.ElementRef<typeof Icon>,
  ButtonIconProps
>((props, ref) => {
  const context = useButton();
  const { loading, icon, mode, ...rest } = { ...context, ...props };
  return loading ? (
    <Spinner size={'md'} />
  ) : (
    <Icon icon={icon} mode={mode} ref={ref} {...rest} />
  );
});

ButtonIcon.displayName = 'Button.Icon';
